import styled from "styled-components";

export const Container = styled.div`
  color: #000;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  height: calc(100% - 2rem);
  width: calc(100% - 2rem);
  padding: 1rem;
`;
